import cx from 'clsx';
import React from 'react';

import useTranslation from '@hooks/useTranslation';

import type { SourceFromType } from '@model/file';

import style from './style.module.scss';

interface IProps {
  sourceFrom?: SourceFromType;
  className?: string;
}

const PhotoLabel = ({ sourceFrom, className }: IProps) => {
  if (!sourceFrom) {
    return null;
  }

  const { t } = useTranslation();

  const imageLabel: { [key in SourceFromType]: string } = {
    mainImage: t('Main Asset Photo'),
    equipmentImage: t('Installation Point Photo'),
    position: t('Installation Point Photo'),
    nodePhoto: t('Node Photo'),
  };

  return (
    <div className={cx(style.galleryImageLabel, className)}>
      <span className={style.labelText}>{imageLabel[sourceFrom]}</span>
    </div>
  );
};

export default PhotoLabel;
